const comments_es = {
  title: "comentarios",
  publish_label: "Publicar un comentario",
  publish_button: "Publicar comentario",
  unlogged: "Inicia sesión para poder comentar",
  empty: "No hay comentarios aún",
};
export default comments_es;
